export default __webpack_public_path__ + "static/media/Maharaja11.89b1d7dc.jpg";